/* src/app/timeline-skip/partials/timeline-skip-accepted-jobs/timeline-skip-accepted-jobs.component.scss */
.header {
  background-color: white;
  color: white;
  border-top: 3px solid #27ae60;
  padding: 0.3rem;
  background: #34495e;
}
.bodyContainer {
  background-color: white;
  height: 95%;
  min-height: 50rem;
}
.acceptedOrdersContainer {
  position: fixed;
  width: 17rem;
  font-size: 0.65rem;
  min-height: 50rem;
  top: 3.5rem;
  left: 4.5rem;
}
.acceptedOrdersContainer .btn-small {
  width: 2rem;
}
.orderContainer {
  background-color: #bdc3c7;
}
.orderContainer.old {
  background-color: pink;
}
.orderContainer {
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}
.dragging {
  opacity: 0.5;
  transform: scale(0.8);
}
.gridPagination {
  width: 100%;
}
.gridPagination ul {
  display: table;
  margin: 0 auto;
  list-style-type: none;
}
.gridPagination li {
  display: inline-block;
}
.gridPagination li a.active {
  text-decoration: underline;
}
/*# sourceMappingURL=timeline-skip-accepted-jobs.component.css.map */
